module.exports = {
    PRIVATE: 0,
    UNLISTED: 1,
    PUBLIC: 2
};